import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(authRoutes)/login/AppLogin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarFallback"] */ "/vercel/path0/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
